/**
 * New-buybox PDP: mark Easy Tabs container, inject chevron SVG, single-open via .easytabs-active on row only.
 */
(function () {
  if (!document.body) {
    return;
  }

  var ROOT_SCOPE_SELECTOR = 'product-page.sh-site-box-container';
  if (!document.querySelector(ROOT_SCOPE_SELECTOR)) {
    return;
  }

  document.body.classList.add('sh-buybox-tabs-scope');

  var MARK = 'data-sh-buybox-easytabs';
  var SEL = '.box__product-content .easytabs-block-container';
  var scheduled = false;

  var CHEVRON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="sh-easytabs-chevron-svg" width="22" height="12" viewBox="0 0 9 5" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M0.583632 0.95793C0.472123 0.853196 0.472122 0.683392 0.583632 0.578658C0.695144 0.473933 0.875937 0.473933 0.98744 0.578658L4.49994 3.87766L8.01256 0.578551C8.12406 0.473817 8.30485 0.473817 8.41637 0.578551C8.52788 0.683285 8.52788 0.853089 8.41637 0.957814L4.7287 4.42134C4.66628 4.47996 4.58216 4.50577 4.50063 4.49877C4.41871 4.50614 4.33404 4.48037 4.2713 4.42145L0.583632 0.95793Z" fill="#6B6B6B" stroke="black"/>' +
    '</svg>';

  /** When one row is open, only it may keep .easytabs-active (Easy Tabs adds it on expand). */
  function removeEasytabsActiveFromOtherRows(box, keepRow) {
    if (!box || !keepRow) return;
    box.querySelectorAll('.easytabs-content-item').forEach(function (row) {
      if (row !== keepRow) {
        row.classList.remove('easytabs-active');
      }
    });
  }

  function syncChevron(header) {
    var ch = header.querySelector(':scope > .sh-easytabs-chevron');
    if (!ch) return;
    var row = header.closest('.easytabs-content-item');
    var expanded = !!(row && row.classList.contains('easytabs-active'));
    ch.classList.toggle('sh-easytabs-chevron--open', expanded);
  }

  function injectChevrons(container) {
    container.querySelectorAll('.easytabs-accordion-item').forEach(function (header) {
      if (!header.closest('.easytabs-content-item')) {
        return;
      }
      var ch = header.querySelector(':scope > .sh-easytabs-chevron');
      if (!ch) {
        ch = document.createElement('span');
        ch.className = 'sh-easytabs-chevron';
        ch.setAttribute('aria-hidden', 'true');
        ch.innerHTML = CHEVRON_SVG;
        header.appendChild(ch);
      } else if (!ch.querySelector('svg')) {
        ch.innerHTML = CHEVRON_SVG;
      }
      syncChevron(header);
    });
  }

  function markContainers() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.getAttribute(MARK) !== '1') {
        el.setAttribute(MARK, '1');
        el.classList.add('sh-easytabs-buybox');
      }
      injectChevrons(el);
    });
  }

  function scheduleMark() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      markContainers();
    });
  }

  function boot() {
    markContainers();
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var box = t.closest('.sh-easytabs-buybox');
    if (!box) return;

    var header = t.closest('.easytabs-accordion-item');
    if (header && header.closest('.easytabs-content-item')) {
      var currentRow = header.closest('.easytabs-content-item');
      function applyExclusiveAndChevrons() {
        if (currentRow.classList.contains('easytabs-active')) {
          removeEasytabsActiveFromOtherRows(box, currentRow);
        }
        injectChevrons(box);
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          applyExclusiveAndChevrons();
          window.setTimeout(applyExclusiveAndChevrons, 32);
        });
      });
    } else {
      window.requestAnimationFrame(function () {
        injectChevrons(box);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', scheduleMark);
})();
